import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	Icon,
	IconButton,
	InputAdornment,
	MenuItem,
	Radio,
	RadioGroup,
	TextField,
	Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'
import { KeyboardDatePicker, TimePicker } from '@material-ui/pickers'
import moment from 'moment'
import React, { useEffect, useState, useMemo } from 'react'
import { Fragment } from 'react'
import {
	STATUS_ID,
	getServiceEarlyDropOffTime,
	endDateIsBeforeOrEqualToStartDate,
	VISIT_TYPES,
	BOARDING,
	DAYCARE,
	COMPATIBILITY_SESSION,
	GROOMING,
	ADDON_ONLY,
	facilityOffersSignatureStay,
	visitHasSignatureStay,
	boardingOptionsWithStayType,
	facilityOffersSignaturePlay,
	visitHasSignaturePlay,
	daycareOptionsWithStayType,
	visitHasBeenCharged,
	STAY_TYPES
} from '../../utils'
import useCurrentUser from '../../hooks/useCurrentUser'
import StyledAlert from '../Common/StyledAlert'
import useConstants from '../../hooks/useConstants'
import StyledSelect from '../Common/StyledSelect'
import StyledSwitchWithLabel from '../Common/StyledSwitchWithLabel'

const lockedStati = [STATUS_ID.Cancelled, STATUS_ID['No Show']]
const chargeStati = [STATUS_ID.Cancelled, STATUS_ID['No Show']]

const cutoffs = {
	0: 'The Day Of',
	1: 'One Day Before',
	2: 'Two Days Before'
}

const useStyles = makeStyles((theme) => ({
	depositBox: {
		padding: 16,
		paddingTop: 24,
		paddingBottom: 24
	},
	depositWarning: {
		backgroundColor: 'rgba(235, 76, 76, 0.1)',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		borderRadius: 6,
		padding: 16
	},
	depositText: {
		color: '#D02C2C',
		fontSize: 16,
		fontWeight: '400'
	},
	checked: {},
	dialog: {
		'& .MuiDialog-paper': {
			maxWidth: '920px'
		}
	},
	fieldWrapper: {
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		},
		'& .MuiDialogContent-root': {
			'& .MuiFilledInput-underline': {
				minWidth: 100
			}
		},
		'& .MuiTextField-root': {
			minWidth: '100px',
			'& .MuiFilledInput-underline': {
				minWidth: 100
				// height: 40
			}
		}
	},
	fieldWrapper2: {
		'& .MuiDialogContent-root': {
			'& .MuiFilledInput-underline': {
				minWidth: 100
			}
		},
		'& .MuiTextField-root': {
			minWidth: '100px',
			'& .MuiFilledInput-underline': {
				minWidth: 100
				// height: 40
			}
		},
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		},
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	datesWrapper: {
		display: 'flex',
		flexWrap: 'wrap'
	},
	timesWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	dialogActions: {
		justifyContent: 'flex-start',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: '.8rem'
	},
	actionButtons: {
		justifyContent: 'flex-start',
		margin: 0,
		display: 'flex',
		gap: '.8rem'
	},
	datePicker: {
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		},
		'&:nth-child(1)': {
			marginRight: '16px !important'
		}
	},
	bigRadio: {
		'& .MuiSvgIcon-root': {
			color: '#3B0275',
			fill: '#3B0275'
		}
	},
	datePicker2: {
		'& .MuiDialogContent-root': {
			'& .MuiFilledInput-underline': {
				minWidth: 100
			}
		},
		'& .MuiTextField-root': {
			minWidth: '100px',
			'& .MuiFilledInput-underline': {
				minWidth: 100
				// height: 40
			}
		}
	},
	timePicker1: {
		'& .MuiTextField-root': {
			minWidth: '100px',
			'& .MuiFilledInput-underline': {
				minWidth: 100
				// height: 40
			}
		}
	},
	smallRow: {
		display: 'flex',
		justifyContent: 'flex-start',
		flexDirection: 'row',

		'& .MuiFilledInput-input': {
			padding: 0,
			paddingLeft: 8
		},
		'& .MuiTextField-root': {
			minWidth: '100px',
			'& .MuiFilledInput-underline': {
				minWidth: 100,
				height: 40
			}
		}
	},
	cancelHeader: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: '800',
		marginTop: 36
	},
	cancelText: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: '600',
		marginTop: 16,
		marginBottom: 24
	},
	cancelText2: {
		fontFamily: 'Nunito',
		fontSize: 12,
		fontWeight: '800',
		marginBottom: 12,
		textTransform: 'uppercase'
	}
}))

const EditAppointmentDetailsDialog = (props) => {
	const classes = useStyles()
	const { isBackOfficeUser, isPcaSupervisorUser } = useCurrentUser()

	const {
		visit,
		startDate,
		visitDate,
		endDate,
		save,
		isShown,
		setIsShown,
		loading,
		relatedPetCareVisit,
		first_day_daycare,
		last_day_daycare,
		facility
	} = props

	const { status, type, extended_pickup, early_dropoff } = visit
	const [isStartDateOpen, setIsStartDateOpen] = useState(false)
	const [isEndDateOpen, setIsEndDateOpen] = useState(false)
	const [appointmentStartDate, setAppointmentStartDate] = useState(null)
	const [appointmentVisitDate, setAppointmentVisitDate] = useState(null)
	const [appointmentEndDate, setAppointmentEndDate] = useState(null)
	const [appointmentStatus, setAppointmentStatus] = useState('')
	const [extendedPickup, setExtendedPickup] = useState(false)
	const [earlyDropOff, setEarlyDropOff] = useState(false)
	const [statusUpdated, setStatusUpdated] = useState(false)
	const [firstDayDaycare, setFirstDayDaycare] = useState(false)
	const [lastDayDaycare, setLastDayDaycare] = useState(false)
	const [sharingKennel, setSharingKennel] = useState(false)
	const [signatureStay, setSignatureStay] = useState(false)
	const [signaturePlay, setSignaturePlay] = useState(false)

	const [visitType, setVisitType] = useState(status)

	const [dropOffTime, updateDropOffTime] = useState(null)
	const [isEnableForm, setIsEnableForm] = useState(true)
	const [dropOffTimeOpen, setDropOffTimeOpen] = useState(false)

	const [pickUpStartTime, updatePickUpStartTime] = useState(null)
	const [pickUpStartOpen, setPickUpStartOpen] = useState(false)

	const [pickUpEndTime, updatePickUpEndTime] = useState(null)
	const [pickUpEndOpen, setPickUpEndOpen] = useState(false)
	const [showOldInvoice, setShowOldInvoice] = useState(false)
	const [chargeAmount, setChargeAmount] = useState(0)
	const [period, setPeriod] = useState('')
	const [chargeFee, setChargeFee] = useState('full')
	const [customFee, setCustomFee] = useState(0)

	const { appointmentStatuses } = useConstants()

	const depositPaid = visit?.deposit_paid || false
	const depositAmount = visit?.deposit_amount || 0

	const isAddonOnlyVisit = visit?.type === ADDON_ONLY

	const canEditAppointmentType = useMemo(() => {
		if (!visit) {
			return false
		}

		const { dates, type } = visit

		if (![BOARDING, DAYCARE].includes(type)) {
			return false
		}

		if ([STATUS_ID.Cancelled, STATUS_ID.Completed, STATUS_ID['No Show']].includes(appointmentStatus?.id)) {
			return false
		}

		const firstDate = dates[0]
		const today = moment().startOf('day').format('YYYY-MM-DD')
		if (firstDate !== today) {
			return false
		}
		return true
	}, [visit, appointmentStatus])

	const visitTypeHasChanged = useMemo(() => {
		if (!canEditAppointmentType) {
			return false
		}
		if (visitType === visit.type) {
			return false
		}
		return true
	}, [visitType, visit, canEditAppointmentType])

	const shouldDisableDateSelections = useMemo(() => {
		if (isAddonOnlyVisit) {
			return true
		}
		if (visit.type !== VISIT_TYPES.Boarding) {
			return false
		}

		if (depositPaid && !isBackOfficeUser && !isPcaSupervisorUser) {
			return true
		}

		return false
	}, [isBackOfficeUser, isPcaSupervisorUser, visit, depositPaid, isAddonOnlyVisit])

	const showWarningRegardingDeposit = useMemo(() => {
		let show = false

		if (!depositPaid || !visit.type === VISIT_TYPES.Boarding) {
			return false
		}

		const newStartDate = moment(appointmentStartDate).startOf('day')
		const newEndDate = moment(appointmentEndDate).endOf('day')
		const orginalStart = moment(startDate).startOf('day')
		const originalEnd = moment(endDate).endOf('day')
		const originalNumberOfDays = originalEnd.diff(orginalStart, 'days')
		const newNumberOfDays = newEndDate.diff(newStartDate, 'days')

		if (newNumberOfDays < originalNumberOfDays && depositPaid) {
			show = true
		}

		return show
	}, [visit, depositPaid, appointmentStartDate, appointmentEndDate, startDate, endDate])

	const showSignatureStayToggle = useMemo(() => {
		const isBoarding =
			(visitTypeHasChanged && visitType === BOARDING) ||
			(!visitTypeHasChanged && visit?.type === BOARDING)
		if (!isBoarding) return false
		return facilityOffersSignatureStay(facility) || visitHasSignatureStay(visit)
	}, [visit, visitType, visitTypeHasChanged, facility])

	const isDaycareEdit =
		(visitTypeHasChanged && visitType === DAYCARE) || (!visitTypeHasChanged && visit?.type === DAYCARE)

	const showSignaturePlayToggle =
		isDaycareEdit && (facilityOffersSignaturePlay(facility) || visitHasSignaturePlay(visit))

	const signaturePlayLocked = visitHasBeenCharged(visit)
	const signaturePlayToggleDisabled =
		signaturePlayLocked ||
		[STATUS_ID.Completed, STATUS_ID.Cancelled, STATUS_ID['No Show']].includes(visit?.status?.id)

	const earlyDropOffRangeText = getServiceEarlyDropOffTime(facility?.services[visit.type])
	const earlyDropOffDisabled = !facility?.early_dropoff_enabled

	let dropoffTimeStart = facility?.services[visit.type]?.dropoff_begins
	let dropoffTimeEnd = facility?.services[visit.type]?.dropoff_deadline

	if (visit.type === 'boarding' && firstDayDaycare) {
		dropoffTimeStart = facility?.services?.daycare?.dropoff_begins
		dropoffTimeEnd = facility?.services?.daycare?.dropoff_deadline
	}

	let ourType = visit.type
	if (ourType === COMPATIBILITY_SESSION) ourType = 'compatibility'

	const dateError = useMemo(() => {
		return endDateIsBeforeOrEqualToStartDate({
			startDate: moment(appointmentStartDate),
			endDate: moment(appointmentEndDate)
		})
	}, [appointmentStartDate, appointmentEndDate])

	useEffect(() => {
		if (first_day_daycare) setFirstDayDaycare(true)
		if (last_day_daycare) setLastDayDaycare(true)

		if (type) {
			setVisitType(type)
		}

		if (startDate) {
			setAppointmentStartDate(startDate)
		}

		if (visitDate) {
			setAppointmentVisitDate(visitDate)
		}

		if (type === 'boarding' && endDate) {
			setAppointmentEndDate(endDate)
		}

		if (extended_pickup) {
			setExtendedPickup(extended_pickup)
		}

		if (early_dropoff) {
			setEarlyDropOff(early_dropoff)
		}

		if (status && appointmentStatuses) {
			setAppointmentStatus(
				appointmentStatuses.find((appointmentStatus) => appointmentStatus.id === status.id)
			)
		}

		if (visit.show_old_invoice) setShowOldInvoice(true)

		if (visit.pickup_time) updatePickUpStartTime(moment(visit.pickup_time, 'HH:mm'))
		if (visit.dropoff_time) updateDropOffTime(moment(visit.dropoff_time, 'HH:mm'))
		if (visit.pickup_end_time) updatePickUpEndTime(moment(visit.pickup_end_time, 'HH:mm'))
		if (visit.sharing_kennels) setSharingKennel(true)
		setSignatureStay(visitHasSignatureStay(visit))
		setSignaturePlay(visitHasSignaturePlay(visit))
	}, [startDate, endDate, visit, appointmentStatuses, type])

	useEffect(() => {
		if (visit?.type === BOARDING && !firstDayDaycare && earlyDropOff) setEarlyDropOff(false)
		if (visit?.type === BOARDING && !lastDayDaycare && extendedPickup) setExtendedPickup(false)
	}, [firstDayDaycare, lastDayDaycare])

	useEffect(() => {
		if (statusUpdated && chargeStati.includes(appointmentStatus.id)) {
			if (!facility.services[ourType].charge_cancellation_fee) return
			if (ourType === GROOMING && status.id === STATUS_ID.Pending) return
			let free_time = facility.services[ourType].free_period_end_time
			let free_date = facility.services[ourType].free_period_end_date

			let mid_time = facility.services[ourType].mid_period_end_time
			let mid_date = facility.services[ourType].mid_period_end_date

			let dayOne = moment(visit.startDate).format('MM-DD-YYYY')

			let fullDayOne = moment(`${dayOne} ${free_time}`, 'MM-DD-YYYY HH:mm')
				.subtract(free_date, 'days')
				.toDate()
			let fullDayTwo = moment(`${dayOne} ${mid_time}`, 'MM-DD-YYYY HH:mm')
				.subtract(mid_date, 'days')
				.toDate()

			let free_hours = moment(facility.services[ourType].free_period_end_time, 'HH:mm').format('h:mm a')
			let free_date_text = cutoffs[facility.services[ourType].free_period_end_date].toLowerCase()
			let extra_dogs = visit.pet_ids.length - 1

			console.log('one...', fullDayOne)
			console.log('two...', fullDayTwo)

			if (moment().isBefore(fullDayOne)) {
				setChargeAmount(0)
				setPeriod(facility.services[ourType].free_period_name)
			} else if (moment().isBefore(fullDayTwo)) {
				let fee_one =
					facility.services[ourType].mid_period_base_fee +
					(facility.services[ourType].mid_period_extra_dog_fee || 0) * extra_dogs

				if (ourType === GROOMING) {
					if (facility.services[ourType].mid_period_fee_type?.toLowerCase().includes('percent')) {
						let percent = facility.services[ourType].mid_period_base_fee_percent
						let price = visit?.quoted_price_min || visit?.price || 5000
						fee_one = price * (percent / 100)
					}
				}

				setChargeAmount(fee_one)
				setPeriod(facility.services[ourType].mid_period_name)
			} else {
				let full_fee =
					facility.services[ourType].final_period_base_fee +
					(facility.services[ourType].final_period_extra_dog_fee || 0) * extra_dogs

				if (ourType === GROOMING) {
					if (facility.services[ourType].final_period_fee_type?.toLowerCase().includes('percent')) {
						let percent = facility.services[ourType].final_period_base_fee_percent
						let price = visit?.quoted_price_min || visit?.price || 5000
						full_fee = price * (percent / 100)
					}
				}

				setChargeAmount(full_fee)
				setPeriod(facility.services[ourType].final_period_name)
			}
		}
	}, [appointmentStatus, statusUpdated])

	const updateStartDate = (date) => {
		setAppointmentStartDate(moment(date).hour(12))
		setIsStartDateOpen(false)
	}

	useEffect(() => {
		if (
			appointmentStatus?.id === STATUS_ID.InProgress ||
			appointmentStatus?.id === STATUS_ID.Approved ||
			appointmentStatus?.id === STATUS_ID.Pending
		) {
			setIsEnableForm(true)
			return
		}
		const isAppStarted = moment(appointmentStartDate).isSameOrBefore(moment(), 'day')
		const isAppEnded = moment(appointmentEndDate).isBefore(moment(), 'day')
		const isVisitDateToday = moment(appointmentVisitDate).isSame(moment(), 'day')
		if (isVisitDateToday || (isAppStarted && !isAppEnded)) {
			setIsEnableForm(true)
		} else {
			setIsEnableForm(false)
		}
		return
	}, [appointmentStatus, appointmentStartDate, appointmentEndDate, ourType])

	const updateEndDate = (date) => {
		setAppointmentEndDate(moment(date).hour(12))
		setIsEndDateOpen(false)
	}

	const hideDialog = () => {
		setAppointmentStartDate(startDate)
		setAppointmentEndDate(endDate)
		setVisitType(type)
		setSignaturePlay(visitHasSignaturePlay(visit))
		if (appointmentStatuses && status) {
			setAppointmentStatus(
				appointmentStatuses.find((appointmentStatus) => appointmentStatus.id === status.id)
			)
		}

		setIsShown(false)
		setStatusUpdated(false)
	}

	const renderDropOffTime = () => {
		const hasQualifyingMembership = visit.household?.memberships
			?.filter((m) => !m.deactived)
			.some(
				(m) =>
					m.type.startsWith('vip') ||
					m.type.startsWith('found') ||
					m.type.startsWith('pet_care')
			)

		if (!earlyDropOff) {
			return (
				<Fragment>
					<Typography
						style={{
							fontWeight: '600',
							color: '#4D4C4F',
							fontSize: '14px'
						}}>
						{`Drop-off between ${moment(dropoffTimeStart, 'HH:mm').format('ha')} - ${moment(
							dropoffTimeEnd,
							'HH:mm'
						).format('ha')}`}
					</Typography>
					<Typography
						style={{
							fontWeight: '600',
							color: '#4D4C4F',
							fontSize: '14px'
						}}>
						Free
					</Typography>
				</Fragment>
			)
		} else {
			return (
				<Fragment>
					<Typography
						style={{
							fontWeight: '600',
							color: '#4D4C4F',
							fontSize: '14px'
						}}>
						Drop-off between {earlyDropOffRangeText}
					</Typography>
					<Typography
						style={{
							fontWeight: '600',
							color: '#4D4C4F',
							fontSize: '14px'
						}}>
						{hasQualifyingMembership ? 'Free' : `$${(facility?.services[visit.type].early_dropoff_fee / 100).toFixed(2)}`}
					</Typography>
				</Fragment>
			)
		}
	}

	const renderPickupTime = () => {
		let isBoarding = visit.type === BOARDING
		let ourType = visit.type

		if (visit.type === BOARDING && lastDayDaycare) ourType = DAYCARE

		if (!extendedPickup) {
			return (
				<div>
					<Typography
						style={{
							fontWeight: '600',
							color: '#4D4C4F',
							fontSize: '14px'
						}}>
						{`Pick up before ${moment(facility?.services[ourType]?.pickup_deadline, 'HH:mm').format(
							'ha'
						)}`}
					</Typography>
					<Typography
						style={{
							fontWeight: '600',
							color: '#4D4C4F',
							fontSize: '14px'
						}}>
						Free
					</Typography>
				</div>
			)
		} else {
			return (
				<div>
					<Typography
						style={{
							fontWeight: '600',
							color: '#4D4C4F',
							fontSize: '14px'
						}}>
						{`Pick up as late as ${moment(
							facility?.services.daycare?.late_pickup_standard_pickup_time,
							'HH:mm'
						).format('ha')}`}
					</Typography>
					<Typography
						style={{
							fontWeight: '600',
							color: '#4D4C4F',
							fontSize: '14px'
						}}>
						Free
					</Typography>
				</div>
			)
		}
	}

	const isStatusDisabled = (status) => {
		if (status.id === STATUS_ID['No Show']) {
			if (moment(visit.startDate).isSame(moment(), 'day')) return false
			return true
		}
		if (visit.status.id === STATUS_ID.Cancelled) return true
		return false
	}

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

	const getCancellationText = () => {
		// get the name of the cancellation window here.....................
		if (chargeAmount === 0) return 'There is no charge for cancelling this visit.'
		if (appointmentStatus?.id === STATUS_ID['No Show'])
			return `Marking this appointment as a no-show will result in the client being charged a $${(
				chargeAmount / 100
			).toFixed(2)} fee. Please confirm below if they should be charged. This action cannot be undone.`
		return `Cancelling during ${period} will result in the client being charged a $${(
			chargeAmount / 100
		).toFixed(2)} fee. Please confirm below if they should be charged. This action cannot be undone.`
	}

	const getDisableForm = () => {
		return !isEnableForm || (appointmentStatus && lockedStati.includes(visit.status.id))
	}

	const handleAppointmentTypeChange = (e) => {
		const { value } = e.target
		setVisitType(value)
		if (value === DAYCARE) {
			setAppointmentEndDate(null)
			setFirstDayDaycare(false)
		}
		if (value === BOARDING) {
			setFirstDayDaycare(true)
		}
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => hideDialog()}
			aria-labelledby="form-dialog-title">
			<DialogTitle>
				{visit?.type === GROOMING ? 'Edit Grooming Appointment' : 'Edit Appointment Details'}
			</DialogTitle>
			<DialogContent style={{ margin: '24px 0px', overflow: 'visible' }}>
				{canEditAppointmentType ? (
					<div className={classes.fieldWrapper2} style={{ marginBottom: 24 }}>
						<div style={{ width: '49%', paddingRight: 4 }}>
							<StyledSelect
								label="Appointment Type"
								header="Edit Appointment Type"
								value={visitType}
								onChange={handleAppointmentTypeChange}>
								{Object.entries(VISIT_TYPES)
									.filter(([key, value]) => [DAYCARE, BOARDING].includes(value))
									.map(([key, value]) => {
										return (
											<MenuItem key={key} value={value}>
												{key}
											</MenuItem>
										)
									})}
							</StyledSelect>
						</div>
					</div>
				) : null}
				<div className={classes.fieldWrapper2}>
					<div style={{ width: '49%', paddingRight: 8 }}>
						<TextField
							select
							style={{ marginBottom: 24 }}
							label="Status"
							variant="filled"
							disabled={getDisableForm()}
							value={appointmentStatus}
							onChange={(e) => {
								setAppointmentStatus(e.target.value)
								setStatusUpdated(true)
							}}>
							{appointmentStatuses
								? appointmentStatuses
										.filter((s) => [1, 2, 4, 5, 7, 8].includes(s.id))
										.map((s) => (
											<MenuItem disabled={isStatusDisabled(s)} key={s.id} value={s}>
												{s.name}
											</MenuItem>
										))
								: []}
						</TextField>
					</div>
					<div style={{ width: '50%' }}>
						<KeyboardDatePicker
							disableToolbar
							style={{
								minWidth: '400px',
								margin: 0
							}}
							InputAdornmentProps={{
								position: 'start',
								component: () => (
									<IconButton onClick={() => setIsStartDateOpen(true)}>
										<Icon
											className="far fa-calendar-alt"
											style={{
												fontSize: '1.325rem'
											}}
										/>
									</IconButton>
								)
							}}
							disabled={shouldDisableDateSelections}
							open={isStartDateOpen}
							onOpen={() => setIsStartDateOpen(true)}
							onClose={() => setIsStartDateOpen(false)}
							variant="inline"
							format="MM/DD/YYYY"
							margin="normal"
							id="start-date"
							label={type === BOARDING ? 'Start Date' : 'Date'}
							inputVariant="filled"
							value={appointmentStartDate}
							onChange={updateStartDate}
							className={classes.datePicker}
							rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
							leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
							KeyboardButtonProps={{
								'aria-label': 'Date',
								className: classes.calendarButton
							}}
						/>
					</div>
				</div>
				<div className={classes.datesWrapper}>
					{(visitTypeHasChanged && visitType === BOARDING) ||
					(appointmentEndDate && type === BOARDING) ? (
						<KeyboardDatePicker
							disableToolbar
							style={{
								minWidth: '400px',
								margin: 0
							}}
							InputAdornmentProps={{
								position: 'start',
								component: () => (
									<IconButton onClick={() => setIsEndDateOpen(true)}>
										<Icon
											className="far fa-calendar-alt"
											style={{
												fontSize: '1.325rem'
											}}
										/>
									</IconButton>
								)
							}}
							disabled={shouldDisableDateSelections}
							open={isEndDateOpen}
							onOpen={() => setIsEndDateOpen(true)}
							onClose={() => setIsEndDateOpen(false)}
							variant="inline"
							format="MM/DD/YYYY"
							margin="normal"
							id="end-date"
							label="End Date"
							inputVariant="filled"
							value={appointmentEndDate}
							onChange={updateEndDate}
							className={classes.datePicker}
							error={dateError}
							helperText={
								dateError ? <span>End date cannot be before or equal to start date</span> : null
							}
							rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
							leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
							KeyboardButtonProps={{
								'aria-label': 'End Date',
								className: classes.calendarButton
							}}
						/>
					) : null}

					{type === BOARDING && visit?.pet_ids?.length > 1 && (
						<TextField
							select
							style={{
								marginBottom: 24,
								minWidth: '400px',
								margin: 0,
								marginRight: '16px'
							}}
							label="Kennel Sharing"
							variant="filled"
							value={sharingKennel}
							onChange={(e) => setSharingKennel(e.target.value)}>
							<MenuItem value={false}>Single Kennels</MenuItem>
							<MenuItem value={true}>Yes, dogs are sharing a kennel</MenuItem>
						</TextField>
					)}

					{showSignatureStayToggle ? (
						<div
							style={{
								minWidth: '400px',
								marginBottom: 24,
								marginRight: '16px',
								alignSelf: 'flex-end'
							}}>
							<StyledSwitchWithLabel
								label="Signature Stay"
								checked={signatureStay}
								onChecked={() => setSignatureStay((prev) => !prev)}
								tooltip={{
									tooltipText:
										'Upgrades overnight rate and includes Signature Stay enrichments at no extra charge.'
								}}
							/>
						</div>
					) : null}

					{showSignaturePlayToggle ? (
						<div
							style={{
								minWidth: '400px',
								marginBottom: 24,
								marginRight: '16px',
								alignSelf: 'flex-end'
							}}>
							<StyledSwitchWithLabel
								label="Signature Play"
								checked={signaturePlay}
								disabled={signaturePlayToggleDisabled}
								onChecked={() => setSignaturePlay((prev) => !prev)}
								tooltip={{
									tooltipText:
										'Adds the Signature Play charge for every dog on this appointment and schedules the Signature Play enrichments at no extra charge. Turning it off removes both.'
								}}
							/>
							{signaturePlayToggleDisabled ? (
								<Typography style={{ color: '#4D4C4F', fontSize: '12px', marginTop: 6 }}>
									{signaturePlayLocked
										? 'This appointment has already been charged, so Signature Play can no longer be changed.'
										: 'Signature Play can no longer be changed on this appointment.'}
								</Typography>
							) : null}
						</div>
					) : null}
				</div>

				{(visitTypeHasChanged && visitType === BOARDING) ||
				(!visitTypeHasChanged && visit?.type === BOARDING) ? (
					<div className={classes.datesWrapper} style={{ marginTop: '24px' }}>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Typography
								style={{
									textTransform: 'uppercase',
									fontWeight: '800',
									color: '#1A1A35',
									fontSize: '12px',
									marginBottom: '10px'
								}}>
								Drop-off Day Daycare
							</Typography>
							<TextField
								select
								style={{
									marginBottom: 24,
									minWidth: '400px',
									margin: 0,
									marginRight: '16px'
								}}
								label="Drop-off Daycare"
								variant="filled"
								disabled={visit?.status?.id === 5}
								value={firstDayDaycare}
								onChange={(e) => setFirstDayDaycare(e.target.value)}>
								<MenuItem value={false}>No, no daycare on drop-off day</MenuItem>
								<MenuItem value={true}>Yes, daycare on drop-off day</MenuItem>
							</TextField>
						</div>

						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Typography
								style={{
									textTransform: 'uppercase',
									fontWeight: '800',
									color: '#1A1A35',
									fontSize: '12px',
									marginBottom: '10px'
								}}>
								Pick-up Day Daycare
							</Typography>
							<TextField
								select
								style={{ marginBottom: 24, minWidth: '400px', margin: 0 }}
								label="Pick-up Daycare"
								variant="filled"
								disabled={visit?.status?.id === STATUS_ID.Completed}
								value={lastDayDaycare}
								onChange={(e) => setLastDayDaycare(e.target.value)}>
								<MenuItem value={false}>No, no daycare on pick-up day</MenuItem>
								<MenuItem value={true}>Yes, daycare on pick-up day</MenuItem>
							</TextField>
						</div>
					</div>
				) : null}

				{visit?.type !== GROOMING && !isAddonOnlyVisit && (
					<div className={classes.datesWrapper} style={{ marginTop: '24px' }}>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Typography
								style={{
									textTransform: 'uppercase',
									fontWeight: '800',
									color: '#1A1A35',
									fontSize: '12px',
									marginBottom: '10px'
								}}>
								Drop-off Time
							</Typography>
							<TextField
								select
								style={{
									marginBottom: 24,
									minWidth: '400px',
									margin: 0,
									marginRight: '16px'
								}}
								label="Drop-off Time"
								variant="filled"
								value={
									((visitTypeHasChanged && visitType === BOARDING) ||
										(!canEditAppointmentType && visit?.type === BOARDING)) &&
									!firstDayDaycare
										? 'Overnight'
										: earlyDropOff
								}
								onChange={(e) => {
									setEarlyDropOff(e.target.value)
								}}
								disabled={
									(((visitTypeHasChanged && visitType === BOARDING) ||
										(!canEditAppointmentType && visit?.type === BOARDING)) &&
										!firstDayDaycare) ||
									earlyDropOffDisabled
								}>
								<MenuItem value={false}>Standard</MenuItem>
								<MenuItem value={true}>Early Drop Off</MenuItem>
								<MenuItem
									style={{ height: 0, opacity: 0, padding: 0, margin: 0 }}
									value="Overnight">
									Overnight
								</MenuItem>
							</TextField>
							<Typography
								style={{
									fontWeight: '700',
									color: '#4D4C4F',
									fontSize: '14px',
									marginTop: '10px'
								}}>
								{`${!earlyDropOff ? 'Standard' : 'Early Drop Off'} Details`}
							</Typography>
							{renderDropOffTime()}
						</div>

						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Typography
								style={{
									textTransform: 'uppercase',
									fontWeight: '800',
									color: '#1A1A35',
									fontSize: '12px',
									marginBottom: '10px'
								}}>
								Pick-up Time
							</Typography>
							<TextField
								select
								style={{ marginBottom: 24, minWidth: '400px', margin: 0 }}
								label="Pick-up Time"
								variant="filled"
								disabled={
									((visitTypeHasChanged && visitType === BOARDING) ||
										(!canEditAppointmentType && visit?.type === BOARDING)) &&
									!lastDayDaycare
								}
								value={
									((visitTypeHasChanged && visitType === BOARDING) ||
										(!canEditAppointmentType && visit?.type === BOARDING)) &&
									!lastDayDaycare
										? 'AM Pick-up'
										: extendedPickup
								}
								onChange={(e) => setExtendedPickup(e.target.value)}>
								{[
									<MenuItem key="menu-01" value={false}>
										Standard
									</MenuItem>,
									<MenuItem key="menu-02" value={true}>
										Late Pick-up
									</MenuItem>,
									<MenuItem
										key="menu-03"
										style={{ height: 0, opacity: 0, padding: 0, margin: 0 }}
										value="AM Pick-up">
										AM Pick-up
									</MenuItem>
								]}
							</TextField>
							<Typography
								style={{
									fontWeight: '700',
									color: '#4D4C4F',
									fontSize: '14px',
									marginTop: '10px'
								}}>
								{`${!extendedPickup ? 'Standard' : 'Late Pick-up'} Details`}
							</Typography>
							{renderPickupTime()}
						</div>
					</div>
				)}

				{/*visit?.type !== 'grooming' && (
					<div className={classes.datesWrapper} style={{ marginTop: '24px' }}>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Typography
								style={{
									textTransform: 'uppercase',
									fontWeight: '800',
									color: '#1A1A35',
									fontSize: '12px',
									marginBottom: '10px'
								}}>
								Charging Method
							</Typography>
							<TextField
								select
								style={{
									marginBottom: 24,
									minWidth: '400px',
									margin: 0,
									marginRight: '16px'
								}}
								label="Charging Method"
								variant="filled"
								value={showOldInvoice}
								disabled={visit?.status?.id === 5}
								onChange={(e) => {
									setShowOldInvoice(e.target.value)
								}}>
								<MenuItem value={false}>New System</MenuItem>
								<MenuItem value={true}>Old System</MenuItem>
							</TextField>
						</div>
					</div>
							)*/}

				{relatedPetCareVisit || visit.type !== GROOMING ? null : (
					<div className={classes.timesWrapper} style={{ marginTop: '24px' }}>
						<div
							className={classes.timePicker1}
							style={{ display: 'flex', flexDirection: 'column', paddingRight: 8, width: '49%' }}>
							<Typography
								style={{
									textTransform: 'uppercase',
									fontWeight: '800',
									color: '#1A1A35',
									fontSize: '12px',
									marginBottom: '10px'
								}}>
								Drop-off Time
							</Typography>
							<TimePicker
								style={{
									minWidth: '400px',
									margin: 0
								}}
								open={dropOffTimeOpen}
								label="Drop-off time"
								onOpen={() => setDropOffTimeOpen(true)}
								onClose={() => setDropOffTimeOpen(false)}
								variant="inline"
								format="hh:mm a"
								margin="normal"
								id="start-date"
								inputVariant="filled"
								value={dropOffTime}
								onChange={(e) => {
									updateDropOffTime(e)
								}}
								className={classes.datePicker2}
								KeyboardButtonProps={{
									'aria-label': 'Date',
									className: classes.calendarButton
								}}
							/>
						</div>

						<div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 8, width: '50%' }}>
							<Typography
								style={{
									textTransform: 'uppercase',
									fontWeight: '800',
									color: '#1A1A35',
									fontSize: '12px',
									marginBottom: '10px'
								}}>
								Pick-up Time Range
							</Typography>
							<div
								className={classes.datePicker2}
								style={{
									width: '100%',
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									alignItems: 'center'
								}}>
								<TimePicker
									style={{
										width: '170px',
										minWidth: '170px',
										margin: 0
									}}
									open={pickUpStartOpen}
									onOpen={() => setPickUpStartOpen(true)}
									onClose={() => setPickUpStartOpen(false)}
									variant="inline"
									format="hh:mm a"
									margin="normal"
									id="start-date"
									inputVariant="filled"
									label="Pick-up start"
									value={pickUpStartTime}
									onChange={(e) => {
										updatePickUpStartTime(e)
									}}
									KeyboardButtonProps={{
										'aria-label': 'Date',
										className: classes.calendarButton
									}}
								/>
								<Typography>To</Typography>
								<TimePicker
									style={{
										width: '170px',
										minWidth: '170px',
										margin: 0
									}}
									open={pickUpEndOpen}
									onOpen={() => setPickUpEndOpen(true)}
									onClose={() => setPickUpEndOpen(false)}
									variant="inline"
									label="Pick-up end"
									format="hh:mm a"
									margin="normal"
									id="start-date"
									inputVariant="filled"
									value={pickUpEndTime}
									onChange={(e) => {
										updatePickUpEndTime(e)
									}}
									KeyboardButtonProps={{
										'aria-label': 'Date',
										className: classes.calendarButton
									}}
								/>
							</div>
						</div>
					</div>
				)}

				{statusUpdated &&
				(appointmentStatus?.id === STATUS_ID.Cancelled ||
					appointmentStatus?.id === STATUS_ID['No Show']) &&
				facility.services[ourType].charge_cancellation_fee &&
				chargeAmount ? (
					<div className={classes.bigRadio}>
						<Typography variant="h5" className={classes.cancelHeader}>
							CONFIRM APPOINTMENT CANCELLATION
						</Typography>
						<Typography variant="body2" className={classes.cancelText}>
							{getCancellationText()}
						</Typography>
						<Typography variant="body2" className={classes.cancelText2}>
							Charge Cancellation Fee?
						</Typography>
						<FormControl className={classes.input}>
							<RadioGroup
								aria-label="has_discount"
								name="has_discount1"
								value={chargeFee}
								onChange={(e) => {
									setChargeFee(e.target.value)
								}}>
								<FormControlLabel
									value="full"
									control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />}
									label="Charge full cancellation fee"
								/>
								<div className={classes.smallRow}>
									<FormControlLabel
										value="custom"
										control={
											<Radio classes={{ root: classes.radio, checked: classes.checked }} />
										}
										label="Charge custom cancellation fee"
									/>
									<TextField
										style={{ width: 100 }}
										variant="filled"
										disabled={chargeFee !== 'custom'}
										onChange={(e) => setCustomFee(parseInt(onlyNumbers(e.target.value)))}
										value={formatNumsToDollars(onlyNumbers(customFee))}
										InputProps={{
											startAdornment: <InputAdornment position="start">$</InputAdornment>
										}}
									/>
								</div>
								<FormControlLabel
									value="waived_fee"
									control={<Radio color="primary" style={{ fill: 'black' }} />}
									label="Waive cancellation fee"
								/>
							</RadioGroup>
						</FormControl>
					</div>
				) : null}
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				{showWarningRegardingDeposit ? (
					<StyledAlert
						type="error"
						text={`The deposit of $${formatNumsToDollars(
							depositAmount
						)} is non-refundable. The cost of service will be revised to reflect the new appointment dates.`}
						style={{ width: '100%' }}
					/>
				) : null}
				<div className={classes.actionButtons}>
					<Button
						variant="contained"
						disabled={
							loading ||
							dateError ||
							(visitTypeHasChanged && visitType === BOARDING && !appointmentEndDate)
						}
						onClick={() => {
							const isBoardingSave =
								(visitTypeHasChanged && visitType === BOARDING) ||
								(!visitTypeHasChanged && visit?.type === BOARDING)
							// Only rewrite daycare stay types when the toggle moved, so saving other
							// fields keeps a mixed booking (some dogs on Signature Play) intact.
							const signaturePlayChanged =
								isDaycareEdit && signaturePlay !== visitHasSignaturePlay(visit)
							let boarding_options
							if (isBoardingSave) {
								boarding_options = boardingOptionsWithStayType(
									visit,
									signatureStay ? 'comfort_plus' : 'standard'
								)
							} else if (signaturePlayChanged) {
								boarding_options = daycareOptionsWithStayType(
									visit,
									signaturePlay ? STAY_TYPES.SignaturePlay : STAY_TYPES.Standard
								)
							}

							save(
								visitTypeHasChanged,
								visitType,
								appointmentStartDate,
								appointmentEndDate,
								appointmentStatus,
								extendedPickup,
								earlyDropOff,
								chargeFee,
								customFee,
								dropOffTime,
								pickUpStartTime,
								pickUpEndTime,
								firstDayDaycare,
								lastDayDaycare,
								sharingKennel,
								showOldInvoice,
								boarding_options
							)
						}}
						color="secondary">
						{loading ? <CircularProgress /> : 'Save'}
					</Button>
					<Button variant="outlined" onClick={() => hideDialog()} color="secondary" disabled={loading}>
						Cancel
					</Button>
				</div>
			</DialogActions>
		</Dialog>
	)
}

export default EditAppointmentDetailsDialog
